import NotificationMessage from "types/notification-message";
import { IProgramConfigurationData, ValidationProblemDetails } from "./client.generated";

export interface MicrosoftCspProgramConfiguration extends IProgramConfigurationData {
  taxableProducts: boolean;
}

export interface AutotaskMicrosoftCspProgramConfiguration extends IProgramConfigurationData {
  vendorId: number | undefined;
  billingCodeId: number;
}

export interface ConnectWiseMicrosoftCspProgramConfiguration
  extends MicrosoftCspProgramConfiguration {
  productSubcategoryId: number | undefined;
  productTypeId: number | undefined;
}

export class ValidationException implements ValidationProblemDetails {
  // implements IValidationException{
  errors: { [key: string]: string[] };

  title: string;

  constructor(errors: { [key: string]: string[] }, title: string) {
    this.errors = errors;
    this.title = title;

    // unused
    this.extensions = {};
  }

  // unused fields that we get from nswag model
  type: string | undefined;

  status: number | undefined;

  detail: string | undefined;

  instance: string | undefined;

  extensions: { [key: string]: unknown };

  public getFirstErrorMessage(): string {
    const errorsGroup = Object.values(this.errors).find((errors) => errors?.length > 0);
    if (errorsGroup) {
      const [message] = errorsGroup; // take 1st item via destructing
      return message ?? NotificationMessage.UNKNOWN_ERROR;
    }

    return NotificationMessage.UNKNOWN_ERROR;
  }

  public static parse = (e: unknown): ValidationException | null => {
    if (
      (e as ValidationException).errors !== undefined &&
      (e as ValidationException).title !== undefined
    ) {
      return new ValidationException(
        (e as ValidationException).errors,
        (e as ValidationException).title,
      );
    }

    return null;
  };
}
